import { render, staticRenderFns } from "./DownloadMenu.vue?vue&type=template&id=3f983959&scoped=true&"
import script from "./DownloadMenu.vue?vue&type=script&lang=js&"
export * from "./DownloadMenu.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMenu.vue?vue&type=style&index=0&id=3f983959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f983959",
  null
  
)

export default component.exports